import { isFSA } from 'flux-standard-action'
import moment from 'moment'
import invariant from 'invariant'
import {
  REPORTS_SHIFTS_SET_LIST_SHIFT,
  REPORTS_SHIFTS_SET_SHIFT_SUMMARY,
  REPORTS_SHIFTS_SET_START_END_DATE,
  REPORTS_SHIFTS_SET_SHIFT_DETAILS,
  REPORTS_SHIFTS_SET_OUTLETS,
  REPORTS_SHIFTS_SET_CURRENT_PAGE
} from 'actions/reports/shifts/constants'
let initialState = {
  shifts: [],
  shiftSummary: {},
  shiftDetails: [],
  startDate: moment().add(-1, 'years').startOf('year'),
  endDate: moment().add(-1, 'years').endOf('year'),
  keyword: '',
  page: 0,
  outlets: []
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  switch (action.type) {
    case REPORTS_SHIFTS_SET_LIST_SHIFT:
      return {...state, shifts: payload.shifts}
    case REPORTS_SHIFTS_SET_SHIFT_SUMMARY:
      return {...state, shiftSummary: payload.summary}
    case REPORTS_SHIFTS_SET_START_END_DATE:
      return {...state, startDate: payload.startDate, endDate: payload.endDate}
    case REPORTS_SHIFTS_SET_SHIFT_DETAILS:
      return {...state, shiftDetails: payload.shiftDetails}
    case REPORTS_SHIFTS_SET_OUTLETS:
      return {...state, outlets: payload.outlets}
    case REPORTS_SHIFTS_SET_CURRENT_PAGE:
      return {...state, page: payload.page}
    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/reports/shifts.js